"use client"

import React from "react";
import RegisterProviderProfile from "../Providers/RegisterProviderProfile";

const ServiceProviderSignUp = () => {
    return <RegisterProviderProfile providerType="service" />;
};

export default ServiceProviderSignUp;
